import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded';
import { tariffsApi } from '../services/api';
import { useShell } from '../components/Layout';
import PageHeader from '../components/common/PageHeader';
import { tokens } from '../theme';

const Step = ({ done, disabled, title, text, action }) => (
  <Card sx={{ opacity: disabled ? 0.6 : 1 }}>
    <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
      {done
        ? <CheckCircleRoundedIcon sx={{ color: tokens.success || '#00A878' }} />
        : <RadioButtonUncheckedRoundedIcon sx={{ color: tokens.inkMuted }} />}
      <Box sx={{ flex: 1, minWidth: 240 }}>
        <Typography variant="h3" sx={{ mb: 0.5 }}>{title}</Typography>
        <Typography color="text.secondary">{text}</Typography>
      </Box>
      {action}
    </CardContent>
  </Card>
);

// «Главная» of an account that may not use the service yet: what to do to open it. Nothing here
// asks the server for data, only for the free trial's terms.
const RestrictedHomePage = () => {
  const { profile, partner } = useShell();
  const navigate = useNavigate();
  const confirmed = profile?.restriction !== 'email_unverified';
  const [trial, setTrial] = useState(null);
  useEffect(() => {
    if (confirmed) tariffsApi.trial().then((r) => setTrial(r.data)).catch(() => {});
  }, [confirmed]);

  const name = profile?.full_name || profile?.email?.split('@')[0] || '';
  const accessText = trial?.available
    ? `Получите бесплатный доступ на ${trial.days} дн. или выберите тариф: в разделе «Тарифы».`
    : 'Выберите и оплатите тариф в разделе «Тарифы», и все разделы откроются.';

  return (
    <Box sx={{ maxWidth: 1000, mx: 'auto' }}>
      <PageHeader overline="Главная" title={name ? `Здравствуйте, ${name}!` : 'Здравствуйте!'}
        subtitle="Чтобы начать работу, пройдите два шага. Пока они не пройдены, работают только «Главная» и «Настройки»." />
      <Stack spacing={2}>
        <Step done={confirmed} title="1. Подтвердите почту"
          text={confirmed ? `Почта ${profile?.email} подтверждена.` : `Мы отправили код на ${profile?.email}. Введите его в разделе «Настройки».`}
          action={!confirmed && <Button variant="contained" onClick={() => navigate('/settings#email-confirm')}>Подтвердить</Button>} />
        <Step disabled={!confirmed} title="2. Откройте доступ" text={accessText}
          action={confirmed && <Button variant="contained" onClick={() => navigate('/tariffs')}>К тарифам</Button>} />
        <Step disabled={!confirmed} title="Хотите приводить клиентов?"
          text={partner === 'none'
            ? 'Станьте партнёром и получайте вознаграждение с первой оплаты каждого приведённого клиента. Заявка подаётся в разделе «Настройки».'
            : 'Ваша заявка в партнёрской программе. Откройте раздел «Партнёрам», чтобы посмотреть её.'}
          action={confirmed && (partner === 'none'
            ? <Button onClick={() => navigate('/settings')}>Подать заявку</Button>
            : <Button onClick={() => navigate('/partner')}>Открыть</Button>)} />
      </Stack>
    </Box>
  );
};

export default RestrictedHomePage;
